import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/kc-white-logo.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon",
  style: {"max-width":"80%"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = {
  class: "sidebar-navbar-nav ps-0 mt-25 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_8 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard", -1)
const _hoisted_11 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-taget" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "AI Precision Picks", -1)
const _hoisted_14 = { class: "sidebar-nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Company Search", -1)
const _hoisted_17 = {
  key: 2,
  class: "sub-title sidebar-nav-item"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Lists", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-envelope" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Inbound", -1)
const _hoisted_23 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-nav-link d-block disabled" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-like" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Favorites")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 5,
  class: "sidebar-nav-item"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-nav-link d-block disabled" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layer" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Custom Lists")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Account Info")
], -1)
const _hoisted_30 = {
  key: 6,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwentyTwo",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwentyTwo"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Settings")
], -1)
const _hoisted_32 = {
  id: "sidebarCollapseTwentyTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_33 = { class: "accordion-body" }
const _hoisted_34 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_35 = { class: "sidebar-sub-menu-item" }
const _hoisted_36 = { class: "sidebar-sub-menu-item" }
const _hoisted_37 = { class: "sidebar-sub-menu-item" }
const _hoisted_38 = { class: "sidebar-sub-menu-item" }
const _hoisted_39 = { class: "sidebar-sub-menu-item" }
const _hoisted_40 = { class: "sidebar-nav-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        (_ctx.canAccessFeature('dashboard'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canAccessFeature('aiPrecisionPicks'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/ai-precision-picks",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: "/search",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        (_ctx.canAccessFeature('inboundList'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true),
        (_ctx.canAccessFeature('inboundList') )
          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: "/inbound",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canAccessFeature('favorites'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (_ctx.canAccessFeature('customLists'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_26, _hoisted_28))
          : _createCommentVNode("", true),
        _hoisted_29,
        (_ctx.canAccessFeature('accountSettings'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("ul", _hoisted_34, [
                    _createElementVNode("li", _hoisted_35, [
                      _createVNode(_component_router_link, {
                        to: "/account-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Account Setting ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_36, [
                      _createVNode(_component_router_link, {
                        to: "/organization-settings",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Org Setting ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_37, [
                      _createVNode(_component_router_link, {
                        to: "/settings-users",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" User Settings ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_38, [
                      _createVNode(_component_router_link, {
                        to: "/settings-change-password",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Change Password ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_39, [
                      _createVNode(_component_router_link, {
                        to: "/settings-delete-account",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Delete Account ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_40, [
          _createVNode(_component_router_link, {
            to: "/logout",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_41,
              _hoisted_42
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}